export enum DropdownTriggerType {
  CLICK = 'click',
  HOVER = 'hover',
}

export enum DropdownPlacement {
  TOP = 'top',
  TOP_LEFT = 'topLeft',
  TOP_RIGHT = 'topRight',
  BOTTOM = 'bottom',
  BOTTOM_LEFT = 'bottomLeft',
  BOTTOM_RIGHT = 'bottomRight',
}
